<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="channel_settings" @selected="switchTab"></TabsWidget>
    </div>
    <div class="wrapper-body">

      <div class="body-panel">
        <div class="form-modal-body">
          <div class="channel-widget-details">
            <div class="channel-details-item space-between">
              <div class="channel-details-content">
                <div class="field-title">Channel full website Link</div>
                <div class="field-value">
                  <input type="text" class="channel-details-input" readonly
                    :value="`${$store.state.SITE_BASE_URL}channel/${form.id}`" />
                </div>
              </div>
              <div class="channel-details-options">
                <b-button type="is-primary" v-clipboard:copy="`${$store.state.SITE_BASE_URL}channel/${form.id}`
                  " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" outlined>COPY</b-button>
              </div>
            </div>
            <div class="channel-details-item space-between">
              <div class="channel-details-content">
                <div class="field-title">Channel Only Link</div>
                <div class="field-value">
                  <input type="text" class="channel-details-input" readonly
                    :value="`${$store.state.SITE_BASE_URL}embend/channel/${form.id}`" />
                </div>
              </div>
              <div class="channel-details-options">
                <b-button type="is-primary" v-clipboard:copy="`${$store.state.SITE_BASE_URL}embend/channel/${form.id}`
                  " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" outlined>COPY</b-button>
              </div>
            </div>
          </div>

          <b-field label="Title">
            <b-input v-model="form.title" value=""></b-input>
          </b-field>
          <div class="row">
            <b-field label="Profile image">
              <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
                :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.profile_image"
                @onFileSelected="(file) => {
                  form.profile_image = file;
                }
                  ">
                <div class="image-upload-widget">Choose Image to upload</div>
              </upload-trigger>
            </b-field>
            <div class="h-spacer"></div>
            <b-field label="Channel cover image">
              <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
                :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.cover_image" @onFileSelected="(file) => {
                  form.cover_image = file;
                }
                  ">
                <div class="image-upload-widget">Choose Image to upload</div>
              </upload-trigger>
            </b-field>
          </div>

          <div class="row">
            <b-field style="width: 100%" label="Phone number">
              <b-input v-model="form.phone"></b-input>
            </b-field>
            <div class="h-spacer"></div>
            <b-field style="width: 100%" label="Email">
              <b-input v-model="form.email"></b-input>
            </b-field>
          </div>

          <b-field style="width: 100%" label="Facebook Link (Optional)">
            <b-input v-model="form.facebook"></b-input>
          </b-field>

          <b-field style="width: 100%" label="Youtube Link (Optional)">
            <b-input v-model="form.youtube"></b-input>
          </b-field>

          <b-field style="width: 100%" label="Instagram Link (Optional)">
            <b-input v-model="form.instagram"></b-input>
          </b-field>
          <b-field style="width: 100%" label="Linkedin Link (Optional)">
            <b-input v-model="form.linkedin"></b-input>
          </b-field>
          <b-field style="width: 100%" label="Tiktok Link (Optional)">
            <b-input v-model="form.tiktok"></b-input>
          </b-field>
          <b-field style="width: 100%" label="Twitter Link (Optional)">
            <b-input v-model="form.twitter"></b-input>
          </b-field>
          <b-field style="width: 100%" label="Pinterest Link (Optional)">
            <b-input v-model="form.pinterest"></b-input>
          </b-field>

          <b-field label="About Channel">
            <b-input v-model="form.about" maxlength="600" type="textarea"></b-input>
          </b-field>
        </div>
      </div>
      <div class="bottom-panel">
        <b-button :loading="submit_loading" @click="updateChannel" type="is-primary">PUBLISH UPDATE</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue"
export default {
  components: {
    TabsWidget
  },
  sockets: {},
  data: () => ({
    channel_details: null,
    loading_channel_details: false,
    selected_date: new Date(),
    isModalActive: true,
    showWeekNumber: false,
    enableSeconds: false,
    hourFormat: undefined, // Browser locale
    locale: undefined, // Browser locale
    firstDayOfWeek: undefined, // 0 - Sunday
    form: {
      id: null,
      title: "",
      profile_image: "",
      cover_image: "",
      phone: "",
      email: "",
      about: "",
      facebook: "",
      youtube: "",
      instagram: "",
      linkedin: "",
      tiktok: "",
      twitter: "",
      pinterest: "",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
  },
  methods: {
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Copy successfully!",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    setChannelDetails(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.profile_image = item.profile_image;
      vm.form.cover_image = item.cover_image;
      vm.form.phone = item.phone;
      vm.form.email = item.email;
      vm.form.about = item.about;
      vm.form.facebook = item.facebook;
      vm.form.youtube = item.youtube;
      vm.form.instagram = item.instagram;
      vm.form.linkedin = item.linkedin;
      vm.form.tiktok = item.tiktok;
      vm.form.twitter = item.twitter;
      vm.form.pinterest = item.pinterest;
    },
    clearDateTime() {
      this.selected = null;
    },
    updateChannel() {
      let vm = this;
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Title can not be empty";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.$store
          .dispatch("CHANNEL_UPDATE_DETAILS", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.image = file;
    },
    getMyChannelDetails(loadVideosEnabled = true) {
      let vm = this;
      vm.loading_channel_details = true;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.loading_channel_details = false;
          vm.channel_details = response.data.return;
          vm.setChannelDetails(vm.channel_details);
        })
        .catch(({ response }) => { });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  @media (max-width:650px) {
    flex-direction: column;
  }


  .wrapper-header {
    height: 100%;
    width: 250px;
    background: #fff;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ddd;
    padding: 10px 15px 0 6px;

    @media (max-width: 650px) {
      width: 100%;
      height: 70px;
      align-items: center;
      flex-direction: row;
      overflow-x: auto;
      column-gap: 10px;
    }

    .tab-item {
      cursor: pointer;
      padding: 14px 4px;
      border-left: 3px solid #fff;

      @media (max-width: 800px) {
        white-space: nowrap;
      }

      img {
        margin: 0 8px 0 10px;
        display: inline-flex;
      }

      &.active {
        color: var(--wecodefy-secondary-color, #9fc953);
        border-left: 3px solid var(--wecodefy-secondary-color, #9fc953);

        @media (max-width: 650px) {
          border-left: unset;
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }
  }

  .wrapper-body {
    width: calc(100% - 250px);
    display: flex;
    background: #fff;
    flex-direction: column;

    @media (max-width: 650px) {
      width: 100%;
      height: calc(100% - 70px);
    }

    .body-panel {
      height: calc(100% - 70px);
      overflow-y: auto;

      .form-modal-body {
        padding: 20px;

        .channel-widget-details {
          padding: 20px;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 30px;

          .channel-details-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;

            @media (max-width: 440px) {
              flex-direction: column;
              row-gap: 15px;
            }

            .channel-details-content {
              width: 70%;

              @media (max-width: 440px) {
                width: 100%;
              }

              .field-title {
                font-size: 14px;
                font-weight: 600;
                color: #333;
              }

              .field-value {
                font-size: 14px;
                font-weight: 400;
                color: #333;

                input {
                  border: 1px solid #ddd;
                  border-radius: 5px;
                  padding: 10px 10px;
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }

    .bottom-panel {
      height: 70px;
      border-top: 1px solid #ddd;
      display: flex;
      align-items: center;
      padding: 0px 20px;
    }
  }
}
</style>
